import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  paper: {
    overflowX: "unset",
    overflowY: "unset",
    "&::before": {
      content: '""',
      position: "absolute",
      marginRight: "-0.71em",
      top: -10,
      right: '50%',
      width: 20,
      height: 20,
      backgroundColor: theme.palette.background.paper,
      transform: "translate(-0%, 0%) rotate(-45deg)",
      clipPath: "polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))",
      border: '1px solid #F3731F',
      boxShadow: 'inset 0px 6px 12px #0000001A, 0px 6px 12px #0000001A'
    }
  },
  popoverImg: {
    width: '100%',
    maxWidth: '100px',
    height: '65px',
    marginBottom: '5px'
  },
  popoverContainer: {
    width: '100%',
    maxWidth: 220,
    textAlign: 'center',
    padding: theme.spacing(1),
    border: '1px solid #F3731F',
    boxShadow: 'inset 0px 6px 12px #0000001A, 0px 6px 12px #0000001A'
  },
  popoverText: {
    fontSize: '12px',
    color: '#000000'
  },
  customStepLabels: {
    '&:hover span': {
      color: '#000000',
      fontWeight: 'bold',
    },
    '&:hover .CustomStepIcon-circle': {
      width: 27,
      height: 27,
    },
    '&:hover .CustomStepIcon-completedIcon': {
      fontSize: 35,
      //transition: 'font-size 100ms'
    },
    '&:hover .CustomStepIcon-errorIcon': {
      fontSize: 35,
      //transition: 'font-size 100ms'
    },
    '&:hover .CustomStepIcon-activeWrapper': {
      minHeight: '80px'
    },
  },
}))

export { useStyles }
